<template>
  <section>
    <b-overlay
      id="overlay-background"
      :show="overlay"
      rounded="sm"
    >
      <template #overlay>
        <div class="text-center">
          <b-spinner
            label="Spinning"
            variant="primary"
          />

          <p class="mt-2">
            <b>Cargando contenido histórico ...</b>
          </p>
        </div>
      </template>

      <b-embed
        type="iframe"
        aspect="1by1"
        src="https://www.indetec.gob.mx/Boletin_eFin2.php"
        allowfullscreen
        @load="overlay = false"
      />
    </b-overlay>
  </section>
</template>

<script>
import { BEmbed, BOverlay, BSpinner } from 'bootstrap-vue'
import { ref, onMounted } from '@vue/composition-api'

export default {
  components: {
    BEmbed,
    BOverlay,
    BSpinner,
  },
  setup() {
    const overlay = ref(false)

    onMounted(() => {
      overlay.value = true
    })

    return {
      overlay,
    }
  },
}
</script>
